import { ReviewableInput } from "ui/widgets/Input";
import type { ReviewableFormInputProps } from "./types";
import FormInputController from "./FormInputController";
import useReviewableFormInput from "./useReviewableFormInput";
import { useConfigContext, withConfig } from "./providers";

const ReviewableFormInput = ({
    name,
    sx,
    slots,
    disabled,
    renderLabel,
    renderFormInput,
    ...restFormikProps
}: ReviewableFormInputProps) => {
    const config = useConfigContext();

    const {
        onApprove,
        onReject,
        getComments,
        onSubmitComments,
        onAddComment,
        onChange
    } = useReviewableFormInput({
        name,
        ...restFormikProps
    });

    return (
        <ReviewableInput.InputComponent
            slots={slots}
            slotProps={{
                iconButton: {
                    disabled
                }
            }}
            subject={name}
            onSubmitComments={onSubmitComments}
            onAddComment={onAddComment}
            onChange={onChange}
            onApprove={onApprove}
            onReject={onReject}
            comments={getComments()}
            renderLabel={renderLabel}
            sx={{
                display: 'grid',
                gridTemplateColumns: '1fr auto',
                ...sx
            }}
        >
            <FormInputController
                fieldsStatuses={restFormikProps.values[config.FieldsStatuses]?.[name]}
            >
                {renderFormInput}
            </FormInputController>
        </ReviewableInput.InputComponent>
    );
};

export default withConfig(ReviewableFormInput);
